export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12087.a329ba75.jpg";